import {DefaultService} from "@/services/default";

export class AirlineService extends DefaultService {
    static resourceURL = 'airline/'

    static dashboard(id, params = {}, headers = {}) {
        return this.execute(`${id}/dashboard/`, 'GET', null, params, headers);
    }

    static requestList(id, params = {}, headers = {}) {
        return this.execute(`${id}/request/`, 'GET', null, params, headers);
    }

    static requestDetail(id,requestId, params = {}, headers = {}) {
        return this.execute(`${id}/request/${requestId}`, 'GET', null, params, headers);
    }
}